module.exports = __webpack_public_path__ + "assets/img/8_1723.71267ee9.jpg";